import { Typography } from 'antd'
import { CIMSTags } from '../../../CIMSTags'
import { RecipientsTagsProps } from './types'
import { useUserTagProps } from '../UserTags/hooks/useUserTagProps'
import { toNonUserEmailTagProps } from '../NonUserEmailTags/utils/toNonUserEmailTagProps'

/**
 * @see {@link RecipientsTagsProps}
 */
const RecipientsTags: React.FC<RecipientsTagsProps> = ({
  recipients,
  noRecipientsContent,
}) => {
  const { nonUserEmails = [], users = [] } = recipients ?? {}
  const toUserTagProps = useUserTagProps({
    color: nonUserEmails.length > 0 ? 'blue' : undefined,
  })
  if (users.length === 0 && nonUserEmails.length === 0) {
    if (noRecipientsContent)
      return <Typography.Paragraph>{noRecipientsContent}</Typography.Paragraph>
    else return null
  }
  return (
    <CIMSTags
      tags={[
        ...users.map(toUserTagProps),
        ...nonUserEmails.map(toNonUserEmailTagProps),
      ]}
    />
  )
}

export default RecipientsTags
